import {
  type RadioGroupProps,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material'
import type { MenuOption } from '../containers/MenuOptions'
import {
  type Control,
  type FieldValues,
  type Path,
  type PathValue,
  useController,
} from 'react-hook-form'

export interface RadioGroupRhfProps<T extends FieldValues> extends RadioGroupProps {
  options: MenuOption[]
  control: Control<T> // Controller attribute from the form
  name: Path<T> // Field name from the form
  onChangeCallback?: (value: PathValue<T, Path<T>>) => void
  isDisabled?: boolean
}

// Default value does not work ? Debug with log

const RadioGroupRhf = <T extends FieldValues>({
  options,
  control,
  name,
  onChangeCallback,
  isDisabled,
  ...radioGroupProps
}: RadioGroupRhfProps<T>) => {
  const {
    field: { value, onChange, onBlur: rhfOnBlur },
  } = useController({
    control,
    name,
  })

  return (
    <FormControl>
      <RadioGroup
        onChange={(e) => {
          onChange(e.target.value as PathValue<T, Path<T>>)
          onChangeCallback?.(e.target.value as PathValue<T, Path<T>>)
        }}
        value={value ?? 0}
        {...radioGroupProps}
        onBlur={rhfOnBlur}
      >
        {options.map((option) => (
          <FormControlLabel
            key={`${option.value}`}
            value={option.value}
            control={<Radio disabled={isDisabled} />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default RadioGroupRhf
